import { singletonAtom } from '@/context/atoms/helper/singletonAtom';
import { publicConfigAtom } from '@/context/atoms/publicConfig';
import { type AuthMechanism, JWTAuthMechanism } from '@ekkogmbh/apisdk';

export const jwtAuthMechanismAtom = singletonAtom<Promise<AuthMechanism>>(async (get) => {
  const publicConfig = await get(publicConfigAtom);
  return new JWTAuthMechanism(publicConfig.env.BACKEND_URL);
});
